<template>
	<div>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="申请售后" goBack="true"></head-top>

		<div class="con_f" style="width: 100%;">
			<div class="afterSale_order">
				<div class="afterSale_title color_d font_size_a" style="padding-top: 0;">
					* 选择售后类型
				</div>
				<van-radio-group v-model="applyType">
					<van-radio name="1">仅退款</van-radio>
					<van-radio name="2" class="margin_top_e">退货退款</van-radio>
				</van-radio-group>
				<div class="afterSale_title color_d font_size_a">
					* 勾选所需售后的书籍并输入数量
				</div>
				<van-checkbox-group v-model="result">
					<div v-for="(item,index) in orderList" :key="index" class="afterSale_order_item">
						<!-- 上半部分，图、名、价格、数量 -->
						<van-checkbox :name="item.orderItemId" shape="square">
							<div class="flex_c afterSale_order_item_right">
								<!-- 满减优惠角标 -->
								<img :src='resourceDomain+"static/icon/discount.png"' class="discountIcon_b"
									v-if="item.afterDiscountPrice">
								<!-- 特价优惠角标 -->
								<img :src='resourceDomain+"static/icon/special.png"' class="discountIcon_b"
									v-if="item.specialOfferStatus">

								<img v-if="item.pic" :src='resourceDomain + item.pic' class="afterSale_prod-pic"></img>
								<div class="afterSale_books_about flex_c" style="flex-direction: column;">
									<div class="ellipsis_2 color_a font_size_b" style="width: 100%;line-height: 1.2;">
										{{item.bookName}}
									</div>

									<div class="flex_c" style="width: 100%;">

										<div v-if="item.afterDiscountPrice||item.specialOfferStatus" class="color_d after_discountPrice">
											<span
												class="font_size_g">￥</span>{{item.afterDiscountPrice?item.afterDiscountPrice:item.specialOfferPrice}}
											<span class="color_e font_size_d" style="text-decoration: line-through;">￥{{item.price}}</span>
										</div>
										<div v-else class="color_d after_discountPrice"><span class="font_size_g">￥</span>{{item.price}}
										</div>

										<!-- 可退数量-->
										<div style="text-align:right" class="color_f">
											x {{item.afterCancelCount}}
										</div>
									</div>
								</div>
							</div>
						</van-checkbox>
						<!-- 下半部分，输入售后数量,正整数 -->
						<div class="flex_a margin_top_d" style="justify-content: flex-end;"
							v-if="result.includes(item.orderItemId)">
							<van-field type="digit" label="售后数量：" placeholder="请输入所需售后的数量"
								v-model="cancelBookNumbers[item.orderItemId]"
								@blur="inputAfterSaleNumber($event,item.orderItemId,item.afterCancelCount)" />
						</div>
					</div>
				</van-checkbox-group>
				<div class="afterSale_title color_d font_size_a">
					* 填写退款理由（ {{applyReason.length}} / 200 ）
				</div>
				<van-field v-model="applyReason" autosize rows="3" label="" type="textarea" maxlength="200"
					placeholder="请输入退款理由" class="after_reason" :border="false" @blur="inputReason" />
				<div class="afterSale_title color_f font_size_a">
					上传图片（ {{filesList.length}} / 6 ）
				</div>

				<van-uploader v-model="filesList" multiple :max-count="6" :deletable="false" :before-read="beforeRead"
					:after-read="afterRead" :before-delete="beforeDelete" @delete="deleteUploadImg" />

				<div class="afterSale_title color_c font_size_b" style="white-space: pre-wrap; ">{{bookRefundExplain}}</div>
			</div>

			<!-- 提交按钮 -->
			<div class="color_b bg_c bookOrderRefund_btn" @click="commitBookOrderRefund">
				提交
			</div>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import {
		mapGetters
	} from 'vuex';
	import {
		ImagePreview
	} from 'vant';
	export default {
		name: 'AfterSaleApplication',
		components: {
			headTop: headTop
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				filesList: [], //临时图片数组
				applyReasonImgs: [], //申请原因图片，最多6张
				bookOrderId: undefined,
				orderList: [], //订单信息
				result: [], //多选的图书的id数组
				applyType: "", //申请类型:1,仅退款,2退款退货
				applyReason: "", //申请原因,最多200字
				cancelBookNumbers: {},
				bookRefundExplain: "" //退款声明
			}
		},
		beforeRouteEnter(to, from, next) {
			// 添加背景色
			document.querySelector('body').setAttribute('style', 'background-color:#fff')
			next()
		},
		created() {
			window.scrollTo(0, 0);
			this.bookOrderId = this.$route.query.id

			this.getRefundItems()
		},

		methods: {
			// 调用组件中的登录成功里的自定义的更新数据事件
			updatePage() {
				this.filesList=[]
				this.applyReasonImgs=[]
				this.result=[]
				this.applyType=''
				this.applyReason=''
				this.cancelBookNumbers={}
				window.scrollTo(0, 0);
				this.getRefundItems()
			},

			// 读取文件前置的处理
			beforeRead(file) {
				let obj = {
					path: "",
					status: "before"
				}
				if (Array.isArray(file)) {
					let number = file.length + this.applyReasonImgs.length
					if (number > 6) {
						this.$toast.fail("最多上传6张")
						file.splice(6 - this.applyReasonImgs.length)
					}
					for (let i of file) {
						this.applyReasonImgs.push(obj)
						console.log(this.applyReasonImgs, "----多-push---")
					}
				} else {
					this.applyReasonImgs.push(obj)
					console.log(this.applyReasonImgs, "----单-push---")
				}
				return true
			},

			// 删除前置处理
			beforeDelete(file) {
				for (let i in this.applyReasonImgs) {
					if ((this.applyReasonImgs)[i].status === "before") {
						this.$toast.fail("有图片上传中，请稍后删除");
						return false
					}
				}
				return true
			},

			// 删除图片
			deleteUploadImg(file, detail) {
				this.applyReasonImgs.splice(detail.index, 1)
			},

			//文件读取完成后的回调函数
			async afterRead(file, detail) {
				let index = detail.index
				let failobj = {
					path: "",
					status: "fail"
				}
				// 看操作是多次单张还是多张单次
				// 如果是多张单次上传的话是一个数组
				if (Array.isArray(file)) {
					for (let i in file) {
						var newIndex = index + Number(i)
						file[i].status = 'uploading';
						file[i].message = '上传中...';
						let fd = new FormData()
						fd.append('file', file[i].file, file[i].file.name)
						await api.upLoadImg("/upload/img", fd).then(res => {
							if (!res.success) {
								this.$toast.fail("图片上传失败,请重新上传!");
								file[i].status = 'failed';
								file[i].message = '上传失败';
								file[i].deletable = true
								this.applyReasonImgs.splice(newIndex, 1, failobj)
								console.log(newIndex, "--------多-图片上传失败,请重新上传------")
							} else {
								file[i].status = 'done';
								file[i].message = '上传成功';
								file[i].deletable = true
								this.$toast.success("上传成功!");
								let successobj = {
									path: res.data,
									status: "success"
								}
								this.applyReasonImgs.splice(newIndex, 1, successobj)
								console.log(newIndex, "--------多-上传成功-----")
							}
						})
					}
				} else {
					console.log(file)
					file.status = 'uploading';
					file.message = '上传中...';
					let fd = new FormData()
					fd.append('file', file.file, file.file.name)
					api.upLoadImg("/upload/img", fd).then(res => {
						if (!res.success) {
							this.$toast.fail("图片上传失败,请重新上传!");
							file.status = 'failed';
							file.message = '上传失败';
							file.deletable = true
							this.applyReasonImgs.splice(index, 1, failobj)
							console.log(index, "--------单-图片上传失败,请重新上传------")
						} else {
							file.status = 'done';
							file.message = '上传成功';
							file.deletable = true
							this.$toast.success("上传成功!");
							let successobj = {
								path: res.data,
								status: "success"
							}
							this.applyReasonImgs.splice(index, 1, successobj);
							console.log(index, "--------单-上传成功------")
						}
					})
				}
				console.log(this.applyReasonImgs, "------async afterRead--------")
			},

			// 输入所选商品需退数量
			inputAfterSaleNumber(event, orderItemId, afterCancelCount) {
				var myNumber = Number(event.target.value)
				if (event.target.value) {
					this.$set(this.cancelBookNumbers, orderItemId, myNumber);
					if (myNumber <= 0 || myNumber > afterCancelCount) {
						this.$toast("请输入有效数量");
						this.$delete(this.cancelBookNumbers, orderItemId);
					}
				} else {
					this.$delete(this.cancelBookNumbers, orderItemId);
				}
				console.log(this.cancelBookNumbers, "---------")
			},

			// 获取订单详情
			getRefundItems() {
				this.$toast.loading({
					overlay: true,
					message: '加载中...',
					duration: 0
				})

				api.post(`/bookOrder/getRefundItems`, {
					bookOrderId: this.bookOrderId
				}).then(res => {
					this.$toast.clear()
					console.log(res, "-----getRefundItems------")
					if (res.success) {
						this.orderList = res.data.bookOrderItemList
						this.bookRefundExplain = res.data.bookRefundExplain
					} else {
						this.$dialog.alert({
							title: '提示',
							message: res.message
						}).then(() => {
							this.$router.go(-1)
						});
					}
				})
			},

			//输入申请原因
			inputReason(event) {
				this.applyReason = (event.target.value).trim()
				console.log(event.target.value, "---------inputReason")
			},

			// 提交售后申请
			commitBookOrderRefund() {
				// 图书有没有勾选
				if (this.result.length == 0) {
					this.$toast("请选择需要售后的图书");
					return false
				}

				// 申请类型有没有选择:1,仅退款,2退款退货
				if (!this.applyType) {
					this.$toast("请选择售后类型");
					return false
				}

				// 申请原因有没有选择
				if (!this.applyReason) {
					this.$toast("请输入申请售后的原因");
					return false
				}

				// 勾选的图书没有输入数量
				for (let i in this.result) {
					var a = (Object.keys(this.cancelBookNumbers)).includes(this.result[i] + "")
					if (!a) {
						this.$toast("请给勾选的图书输入数量");
						return false
					}
				}

				// 上传的图片状态是否正常
				for (let i in this.applyReasonImgs) {
					if ((this.applyReasonImgs)[i].status === "fail") {
						this.$toast.fail("有图片上传失败，请删除或重新上传");
						return false
					} else if ((this.applyReasonImgs)[i].status === "before") {
						this.$toast.fail("有图片上传中，请稍候");
						return false
					}
				}

				// 走接口
				api.post(`/bookOrder/commitBookOrderRefund`, {
					cancelBookNumbers: JSON.stringify(this.cancelBookNumbers),
					applyType: this.applyType,
					applyReason: this.applyReason,
					applyReasonImgs: JSON.stringify(this.applyReasonImgs),
					orderId: this.bookOrderId
				}).then(res => {
					this.$toast.clear()
					console.log(res, "-----commitBookOrderRefund------")
					if (res.success) {
						this.$toast.success({
							message: '提交成功',
							forbidClick: true,
							duration: 2000
						});
						setTimeout(() => {
							this.$router.go(-1)
						}, 2000);
					} else {
						this.$toast(res.message);
					}
				})
			},
		}
	}
</script>

<style>
	.margin_top_d .van-cell {
		padding: 0;
		width: 317px;
	}

	.margin_top_d .van-cell__title,
	.margin_top_d input {
		font-size: 15px;
	}

	.afterSale_order .van-uploader__upload {
		margin: 0
	}

	.afterSale_order .van-uploader__preview {
		margin-right: 24px;
		margin-bottom: 24px;
	}

	.afterSale_order .van-uploader__preview:nth-child(3n) {
		margin-right: 0 !important;
	}

	.afterSale_order .van-uploader__upload,
	.afterSale_order .van-uploader__preview-image,
	.afterSale_order .van-uploader__file {
		width: 99px;
		height: 99px;
	}

	.afterSale_order .van-uploader__preview-delete {
		width: 20px;
		height: 20px;
		border-radius: 0 0 0 20px;
	}

	.afterSale_order .van-uploader__preview-delete-icon {
		font-size: 20px;
	}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
	.con_f {
		padding-top: 48px;
		padding-bottom: 15px;
	}

	.afterSale_title {
		padding: 25px 0 15px;
	}

	.bookOrderRefund_btn {
		width: 345px;
		height: 45px;
		line-height: 45px;
		text-align: center;
		border-radius: 23px;
		margin: 0 auto;
		font-size: 17px;
	}

	.afterSale_order {
		padding: 20px 15px 10px;
	}

	.afterSale_order_item {
		padding-bottom: 15px;
		margin-bottom: 15px;
		border-bottom: 1px solid #f1f1f1;
		font-size: 14px;
	}

	.afterSale_order_item:last-child {
		margin-bottom: 0 !important;
	}

	.afterSale_prod-pic {
		display: block;
		width: 110px;
		height: 55px;
		border-radius: 8px;
	}

	.afterSale_books_about {
		width: 192px;
		height: 55px;
	}

	.afterSale_order_item_right {
		width: 317px;
		position: relative;
	}

	.after_discountPrice {
		font-size: 17px;
	}

	.margin_right_b {
		margin-right: 12px;
	}

	.font_size_g {
		font-size: 10px;
	}

	.margin_top_d {
		margin-top: 15px;
	}

	.margin_top_e {
		margin-top: 10px;
	}


	.after_reason {
		width: 345px;
		padding: 0;
		line-height: 20px;
		resize: none;
		border: none;
		text-align: left;
	}

	// 满减优惠活动角标
	.discountIcon_b {
		position: absolute;
		left: 0;
		top: 0;
		width: 30px;
		height: 16.5px;
		display: block;
		border-top-left-radius: 5px;
	}
</style>